module.exports = __webpack_public_path__ + "static/foto_minigaleria1-6625748c1e74a31ca47fb02ab93cb6a0.jpg";